const constants = {
  set: 'BOARD_TIMELINE_SET',
};

const set = (boardTimeline) => ({
  type: constants.set,
  payload: boardTimeline,
});

const boardTimelineActions = {
  constants,
  set,
};

export default boardTimelineActions;
